
import Vue from 'vue';
import ArticleAuthor from '@root/views/article/components/authors/ArticleAuthor.vue';
import { Author } from '@root/modules/article/types/article';

interface Props {
  authors: Author[];
}

interface Computed {
  showPictureAndEmail: boolean;
  showAuthorInfo: boolean;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    ArticleAuthor,
  },
  props: {
    authors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    showPictureAndEmail() {
      return this.authors.length <= 2;
    },
    showAuthorInfo() {
      return this.authors.length < 5;
    },
  },
});
